export default "__VITE_ASSET__iY1Ot$Nx__"